export default __webpack_public_path__ + "static/media/java-icon.a5cf1255.svg";